import { render } from "./RevisiPenyusunanDokumenPemilihan.vue?vue&type=template&id=21cda10c&scoped=true"
import script from "./RevisiPenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"
export * from "./RevisiPenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"

import "./RevisiPenyusunanDokumenPemilihan.vue?vue&type=style&index=0&id=21cda10c&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cda10c"]])

export default __exports__